import Axios from 'axios'
import { URLS } from './constants'

const BASE_URL = `${URLS.URL_PRD}/journeys`;

const journeysAPI = {
  getJourneys: async () => {
    const { data } = await Axios.get(BASE_URL);
    return data.journeys;
  },

  createJourney: async (code, name, pname) => {
    const body = {
      journey: {
        code,
        name,
        pname,
        description: "",
      },
    };
    await Axios.post(BASE_URL, body);
  },

  updateJourneys: async (id, code, name, pname) => {
    const body = {
      journey: {
        code,
        name,
        pname,
      },
    };
    await Axios.put(`${BASE_URL}/${id}`, body);
  },

  deleteJourney: async (id) => {
    await Axios.delete(`${BASE_URL}/${id}`);
  },
};

export default journeysAPI
